import type { FC } from 'react';

interface ImageGridProps {
  imageUrls: string[];
  onImageClick: (index: number) => void;
}

const getGridClass = (count: number): string => {
  if (count === 1) return 'image-grid image-grid--single';
  if (count === 2) return 'image-grid image-grid--two';
  if (count === 3) return 'image-grid image-grid--three';
  return 'image-grid image-grid--four-plus';
};

export const ImageGrid: FC<ImageGridProps> = ({ imageUrls, onImageClick }) => {
  const displayUrls = imageUrls.slice(0, 4);
  const remainingCount = imageUrls.length - 3;

  return (
    <div className={getGridClass(imageUrls.length)}>
      {displayUrls.map((url, index) => (
        <div
          key={url}
          className="image-grid-cell"
          onClick={() => onImageClick(index)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onImageClick(index);
          }}
          role="button"
          tabIndex={0}
        >
          <img alt={`Attachment ${index + 1}`} src={url} loading="lazy" />
          {imageUrls.length > 4 && index === 3 && (
            <div className="image-grid-overlay">+{remainingCount}</div>
          )}
        </div>
      ))}
    </div>
  );
};
